const routes = [
  {
    path: "/notifications",
    component: () => import(/* webpackChunkName: "EventsIndex" */ "./components/NotificationPane/NotificationPane"),
  },
];
export default routes;
